module.exports = __webpack_public_path__ + "static/media/logos_squares_Sup_HKPU.32d16f0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/logos_squares_Sup_HKPU.png
// module id = 69
// module chunks = 0